/* Place des Arts — carrousel scroll-snap générique.
   <pda-scroller> enveloppe un conteneur [data-scroll-track] (overflow-x + scroll-snap)
   et des boutons [data-scroll-prev] / [data-scroll-next] (n'importe où à l'intérieur).
   Les flèches défilent d'un « pas » (largeur du 1er enfant + gap) ; désactivées aux
   extrémités. Aucune dépendance au slideshow Horizon (contenu custom : avis, artistes). */
class PdaScroller extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-scroll-track]');
    if (!this.track) return;
    this.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      if (t.closest('[data-scroll-prev]')) this.scrollByStep(-1);
      else if (t.closest('[data-scroll-next]')) this.scrollByStep(1);
    });
    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows());
    // Un scroller SSR caché (carrousels bas de la cascade 03/08) mesure 0/0 au
    // connectedCallback → next restait disabled après démasquage. L'observer suit
    // la piste : démasquage ET masquage de cards recalculent les flèches.
    new ResizeObserver(() => this.updateArrows()).observe(this.track);
    this.updateArrows();
  }
  step() {
    const item = this.track.firstElementChild;
    if (!item) return this.track.clientWidth;
    const cs = getComputedStyle(this.track);
    const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }
  scrollByStep(dir) {
    this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
  }
  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth - 1;
    const x = this.track.scrollLeft;
    for (const b of this.querySelectorAll('[data-scroll-prev]')) b.disabled = x <= 0;
    for (const b of this.querySelectorAll('[data-scroll-next]')) b.disabled = x >= max;
  }
}
if (!customElements.get('pda-scroller')) customElements.define('pda-scroller', PdaScroller);
